import React from 'react'
import AboutServiceCard from './AboutServiceCard'
import { SlChemistry } from "react-icons/sl";
import { GiDrippingTube } from "react-icons/gi";
import { GiMicroscope } from "react-icons/gi";
import { BsFileMedical } from "react-icons/bs";
import { GrMoney } from "react-icons/gr";
import { MdLocationCity } from "react-icons/md";
import HeadingTexts from '../../common/HeadingTexts';
import sImg1 from "../../../Assets/Images/ourService1.png"
import sImg2 from "../../../Assets/Images/ourService2.png"
import sImg3 from "../../../Assets/Images/ourService3.png"
import sImg4 from "../../../Assets/Images/ourService4.png"
import sImg5 from "../../../Assets/Images/ourService5.png"
import sImg6 from "../../../Assets/Images/ourService6.png"


const aboutServiceData = [
  {
    label: 'State-of-the-art pathology laboratory with advanced technology', img: sImg5, icon: <SlChemistry />
  },
  {
    label: 'Experienced and board-certified pathologists', img: sImg4, icon: <GiDrippingTube />
  },
  {
    label: 'Comprehensive pathology test menu under one roof', img: sImg3, icon: <GiMicroscope />
  },
  {
    label: 'Fast, accurate, and reliable reports', img: sImg2, icon: <BsFileMedical />
  },
  {
    label: 'Affordable pricing and patient-centric approach', img: sImg1, icon: <GrMoney />
  },
  {
    label: 'Nationwide reach, including remote and underserved areas', img: sImg6, icon: <MdLocationCity />
  },
]

const AboutOutService = () => {
  return (
    <section className='md:px-10 px-6 pb-14 '>
      <div>
        <HeadingTexts label='Why Choose Us' text='Delivering Trusted Diagnostics with' bluetext='Precision and Compassion.' position='center' />
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-stretch justify-stretch justify-items-stretch w-full pb-4 gap-5 mt-10'>
          {
            aboutServiceData.map(({ label, icon, img }, index) => (
              <AboutServiceCard key={index} label={label} icon={icon} img={img} />
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default AboutOutService